import React from 'react';
import { IAuditoriaServicosTerceirosPfResultado } from '../interfaces/IAuditoriaServicosTerceirosPf';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaServicosTerceirosPfResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Conformidade — Serviços de Terceiros (Pessoa Física) / RPA — não é um tributo, é
// uma auditoria de risco previdenciário/fiscal que varre as contas vinculadas ao referencial real
// de "Serviços Prestados por Terceiros" procurando pagamentos a pessoa física sem CPF no histórico
// (CPC 25, Lei 8.212/1991, Lei 10.666/2003).
const AuditoriaResumoServicosTerceirosPf: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.totalAlertas;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Serviços de Terceiros (Pessoa Física)</h3>
      <p className='text-muted'>
        Auditoria complementar — pagamentos a pessoa física sem CPF no histórico, em conta de serviços a terceiros,
        exigem validação de RPA e dos encargos previdenciários e fiscais (CPC 25). Clique para ver a análise
        detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Risco Tributário</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center' title='Nome não indica claramente PJ nem tem evidência objetiva de PF/RPA — requer validação manual'>Pendentes</th>
              <th className='text-center'>Alertas</th>
              <th className='text-center' title='Avaliados e descartados por evidência de Pessoa Jurídica, CPF já citado, ou fornecedor conhecido'>Descartados</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_SERVICOS_TERCEIROS_PF')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Serviços de Terceiros (Pessoa Física) — Conformidade RPA</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} pagamento{totalOcorrencias === 1 ? '' : 's'} a pessoa física/RPA confirmado{totalOcorrencias === 1 ? '' : 's'} de {resultado.totalLancamentosAnalisados} analisado{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>INSS Patronal + INSS Autônomo + IRRF (CPC 25)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-pendente'>{resultado.totalPendentes}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-secundario'>{resultado.totalDescartados}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoServicosTerceirosPf;
